import styled from 'styled-components';
import { baseElementStyles, baseEditorStyles } from '../../styles';

type FormattedRichTextContentProps = {
  $customStyles?: string;
};

export const FormattedRichTextContent = styled.div<FormattedRichTextContentProps>`
  ${baseEditorStyles}
  ${({ $customStyles }) => $customStyles || baseElementStyles}

  overflow-wrap: break-word;

  // The old clearfix hack for floats
  // Prevents user generated content containing floats from breaking the layout
  &::after {
    content: '';
    clear: both;
    display: table;
  }
`;
